<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <div *ngFor="let column of displayedColumns; first as isFirst;">
      <ng-container matColumnDef="{{column}}" *ngIf="column != 'icons'">
        <th mat-header-cell *matHeaderCellDef>
            <span *ngIf="isFirst" [style.paddingLeft.px]="40"> {{column | titlecase}} </span>
            <span *ngIf="!isFirst"> {{column | titlecase}} </span>
        </th>
        <td mat-cell *matCellDef="let data">
            <button mat-icon-button *ngIf="isFirst"
                    [style.visibility]="!data.expandable ? 'hidden' : ''"
                    [style.marginLeft.px]="data.level * 32"
                    (click)="treeControl.toggle(data)">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </button>
            
            <span>{{data[column]}}</span> 
        </td>
      </ng-container>
      <ng-container matColumnDef="icons" *ngIf="column == 'icons'">
        <th mat-header-cell *matHeaderCellDef>
            <span > {{column | titlecase}} </span>
        </th>
        <td mat-cell *matCellDef="let data" class="icon-layout">
            <button mat-icon-button *ngFor="let icon of data[column]" (click)="icon.onClick()" [disabled]="icon.disabled" [hidden]="icon.hidden">
               <mat-icon [matTooltip]="icon.tooltip" [matTooltipPosition]="'above'">{{icon.name}}</mat-icon>
            </button>
        </td>
      </ng-container>
    </div>
  
    <ng-container *ngIf="showHeader">
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>        
    </ng-container>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [style.marginLeft.px]="row.level * 32"></tr>

</table>